<h2 class="confirm-dialog-title">CONFIRMAR CAMBIOS REALIZADOS</h2>
<mat-dialog-content class="confirm-dialog-content">
  <p>{{ data }}.</p>
  <p>¿Desea guardar cambios efectuados?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close (click)="onNoClick()">Cancelar</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true">Confirmar</button>
</mat-dialog-actions>
